import { Subject } from 'rxjs';
import { distinct, groupBy, mergeMap, throttleTime } from 'rxjs/operators';

import { Inject, Injectable } from '@angular/core';

import { DIALOG_MESSAGE, IDialogMessage } from '../model/dialog-message.model';

interface IMessage {
  content: string;
  type: 'info' | 'error' | 'confirm' | 'success';
  onOkHandler?: () => void;
  onCancelHandler?: () => void;
}

@Injectable()
export class DialogMessage {
  private showMessage$ = new Subject<IMessage>();

  constructor(@Inject(DIALOG_MESSAGE) private dialogMessage: IDialogMessage) {
    this.showMessage$.pipe(
      groupBy(m => m.content),
      mergeMap(grouped => grouped.pipe(
        throttleTime(100)
      ))
    ).subscribe(message => {
      switch (message.type) {
        case 'info':
          this.dialogMessage.showInfoMessage(message.content, message.onOkHandler);
          break;
        case 'error':
          this.dialogMessage.showErrorMessage(message.content, message.onOkHandler);
          break;
        case 'confirm':
          this.dialogMessage.showConfirmMessage(message.content, message.onOkHandler, message.onCancelHandler);
          break;
        case 'success':
          this.dialogMessage.showSuccessMessage(message.content, message.onOkHandler);
          break;
      }
    });
  }

  showInfoMessage(message: string, onOkHandler?: () => void): void {
    this.showMessage$.next({ content: message, type: 'info', onOkHandler });
  }

  showErrorMessage(message: string, onOkHandler?: () => void): void {
    this.showMessage$.next({ content: message, type: 'error', onOkHandler });
  }

  showConfirmMessage(message: string, onOkHandler: () => void, onCancelHandler?: () => void): void {
    this.showMessage$.next({ content: message, type: 'confirm', onOkHandler, onCancelHandler });
  }

  showSuccessMessage(message: string, onOkHandler?: () => void): void {
    this.showMessage$.next({ content: message, type: 'success', onOkHandler });
  }
}
